import React, { useState, useEffect } from 'react'
import { Panel, Table } from 'rsuite'

export default function QualificationResponsinatorTableView({ schema: _schema, header, ...prop }) {
  const { Column, HeaderCell, Cell, Pagination } = Table
  const [schema, setSchema] = useState(_schema)

  return (
    <Panel header={header} bordered collapsible defaultExpanded style={{ marginTop: 20 }}>
      <p>{`ระบุข้อมูลโครงการ/งานในความรับผิดชอบที่อยู่ระหว่างดำเนินการทั้งของ สสส. และหน่วยงานอื่นๆ`}</p>
      <br />
      <Table headerHeight={100} autoHeight data={schema || []}>
        <Column align="center" width={80} fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(rowData, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column width={250}>
          <HeaderCell align="center" style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
            ชื่อหน่วยงานให้ทุน
            <br />
            สสส./อื่น ๆ (โปรดระบุ)
          </HeaderCell>
          <Cell>
            {(rowData, index) => {
              if (!rowData.isDeletable) {
                return 'หน่วยงานสสส.'
              } else {
                return rowData.organizationNameOther
              }
            }}
          </Cell>
        </Column>

        <Column flexGrow={1} minWidth={250}>
          <HeaderCell align="center" style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
            ชื่อโครงการ <br />
            (ที่อยู่ระหว่างดำเนินการ)
          </HeaderCell>
          <Cell dataKey="projectName" />
        </Column>

        <Column width={120}>
          <HeaderCell align="center" style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
            รหัสโครงการ (ถ้ามี)
          </HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>

        <Column align="center" width={140}>
          <HeaderCell>
            วันที่สิ้นสุด
            <br />
            โครงการ
          </HeaderCell>
          <Cell dataKey="projectEndDate" />
        </Column>

        <Column width={150}>
          <HeaderCell align="center" style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
            ปริมาณงานที่
            <br />
            รับผิดชอบคิด
            <br />
            เป็นสัตส่วนร้อยละ
          </HeaderCell>
          <Cell align="right" dataKey="responsiblePercent" />
        </Column>
      </Table>
    </Panel>
  )
}
